/**
 * Created by lu on 2017/7/22.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init:function () {
            // this.onChange('blur',function () {
            //     this.check();
            // },this);
        },
        checkInputEmpty: function (inModel, inErrorMsg) {
            var value = inModel.get('value') || '';
            if (!value || value.trim().length == 0) {
                // inModel.set('focus', true, {skipSameValue: false});
                // inModel.set('value', null);
                inModel.set('errorStatus', 'error');
                inModel.set('errorMsg', inErrorMsg || '这个是必填项。');
                return true;
            }
        },
        confirmPassword: function (inPassword, inPassword2) {
            var value1 = inPassword.get('value') ||'';
            var value2 = inPassword2.get('value')||'';
            if (value1 != value2 || value2 == "") {
                // inPassword2.set('value', null);
                inPassword2.set('errorStatus', 'error');
                inPassword2.set('errorMsg', '两次密码输入不一致,请重新输入');
                return true;
            }
        },
        _setErrorInfo: function (inModel, inErrorInfo) {
            // inModel.set('focus', true, {skipSameValue: false});
            // inModel.set('value', '');
            inModel.set('errorStatus', 'error');
            inModel.set('placeholder', inErrorInfo);
            inModel.set('errorMsg', inErrorInfo);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/form/Input.js
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32